/* eslint-disable default-param-last */
import { CRM_TYPES } from "../../../../constants/crmConstants";

const DOMAINS = {
  usAutoSales: "https://usautosales.lightning.force.com",
  DealerSocket: "https://bb.dealersocket.com",
  VinSolution: "https://vinsolutions.app.coxautoinc.com",
  ELead: "https://www.eleadcrm.com",
  Tekion: "https://app.tekioncloud.com",
  dealerTeam:
    process.env.GATSBY_APP_ENVIRONMENT === "prod"
      ? "https://aesvans.my.salesforce.com"
      : "https://socialminingai-devorg-dev-ed.lightning.force.com",
};
/**
 * @param crmType String (DS | SF | VIN | TK)
 * @param isOpportunity Boolean (true: opportunity | false: lead)
 * @param opportunityId Int (Opportunity id)
 * @param leadId Int (Only Required for DS)
 * @param salesForceType String (Domain Salesforce CRM, required when crmType is SF)
 * @return Link (String)
 * */

export const crmLinkGeneration = (
  crmType,
  isOpportunity = true,
  opportunityId,
  leadId,
  salesForceType = CRM_TYPES.SALESFORCE,
  companyId = 0
) => {
  try {
    let Link = null;
    if (crmType === CRM_TYPES.DEALERSOCKET) {
      if (isOpportunity) {
        Link = `${DOMAINS.DealerSocket}/#/crm/sales/view/${leadId}/${opportunityId}`;
      } else {
        Link = `${DOMAINS.DealerSocket}/#/crm/view/contact/${leadId}`;
      }
    } else if (crmType === CRM_TYPES.SALESFORCE) {
      if (isOpportunity) {
        Link = `${DOMAINS[salesForceType]}/lightning/r/Opportunity/${opportunityId}/view`;
      } else {
        Link = `${DOMAINS[salesForceType]}/lightning/r/Lead/${leadId}/view`;
      }
    } else if (crmType === CRM_TYPES.DEALER_TEAM) {
      if (process.env.GATSBY_APP_ENVIRONMENT === "prod" && companyId === "167") {
        Link = `https://worktrailer.my.salesforce.com/lightning/r/dealer__Sales_Up__c/${opportunityId}/view`;
      } else if (isOpportunity) {
        Link = `${DOMAINS[salesForceType]}/lightning/r/dealer__Sales_Up__c/${opportunityId}/view`;
      } else {
        Link = `${DOMAINS[salesForceType]}/lightning/r/Account/${opportunityId}/view`;
      }
    } else if (crmType === CRM_TYPES.VIN_SOLUTIONS) {
      Link = `${DOMAINS.VinSolution}/vinconnect/#/CarDashboard/Pages/LeadManagement/ActiveLeadsLayout.aspx?SelectedTab=t_ILM&leftpaneframe=HIDE&rightpaneframe=/CarDashboard/Pages/CRM/CustomerDashboard.aspx?GlobalCustomerID=${opportunityId}`;
    } else if (crmType === CRM_TYPES.EL) {
      Link = `${
        DOMAINS.ELead
      }/evo2/fresh/elead-v45/elead_track/search/searchresults.asp?Go=2&searchexternal=&corpStore=false&st=0&lIUID=&etitle=&lDID=&PID=&origStrDo=&qs=true&q=${opportunityId.replace(
        / /g,
        "+"
      )}#`;
    } else if (crmType === CRM_TYPES.TEKION) {
      // Service-appointment opportunities are synthesized on our side with a
      // svc_appt_ prefix on tk_lead_id since Tekion has no real lead record
      // for them. Route those to the booking-confirmation view. Sales
      // appointments share the sales lead URL and fall through to the
      // /crm/lead/{id} branch below.
      if (typeof opportunityId === "string" && opportunityId.startsWith("svc_appt_")) {
        const appointmentId = opportunityId.slice("svc_appt_".length);
        Link = `${DOMAINS.Tekion}/dse-v2/bdc/booking-confirmation/${appointmentId}`;
      } else {
        Link = `${DOMAINS.Tekion}/crm/lead/${opportunityId}`;
      }
    }
    return Link;
  } catch (err) {
    console.error(err);
  }
};
